import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_EVALUATIONCRITERIA } from "../../../../utils/constants";
import { EvaluationCriteriaInterface } from "../../../../models/ProcurementModule/EvaluationCriteria";
import EvaluationCriteriaService from "../../../../services/procurementService/EvaluationCriteriaService";

interface AddEvaluationCriteria {
  previousEvaluationCriteria: EvaluationCriteriaInterface[];
}

const useAddEvaluationCriteria = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    EvaluationCriteriaInterface,
    Error,
    EvaluationCriteriaInterface,
    AddEvaluationCriteria
  >({
    mutationFn: EvaluationCriteriaService.Create,

    onMutate: () => {
      const previousEvaluationCriteria =
        queryClient.getQueryData<EvaluationCriteriaInterface[]>([
          CACHE_KEY_EVALUATIONCRITERIA,
          page,
          pageSize,
        ]) || [];

      return { previousEvaluationCriteria };
    },

    onSuccess: (savedData) => {
      queryClient.setQueryData<EvaluationCriteriaInterface[]>(
        [CACHE_KEY_EVALUATIONCRITERIA, page, pageSize],
        (data) => (data ? [savedData, ...data] : [savedData])
      );
    },

    onError: (error, newData, context) => {
      if (!context) return;

      queryClient.setQueryData<EvaluationCriteriaInterface[]>(
        [CACHE_KEY_EVALUATIONCRITERIA, page, pageSize],
        context.previousEvaluationCriteria
      );
    },
  });
};

export default useAddEvaluationCriteria;
